export const BASE_PARAMS = {
    domain: {
        name: 'hawks',
    },
    publisher: {
        domain: 'buyers',
        sub_domain: 'hawks',
    },
    feature: {
        name: 'collections_events',
    },
};
